import Cloudes from '../../shared/ui/Cloudes/Cloudes';
import Sound from '../../shared/ui/Sound/Sound';
import nextImg from '../../shared/assets/images/next.svg';
import cls from './Onboarding.module.scss';
import { useDispatch, useSelector } from 'react-redux';
import { setOnboardingPage, setPage } from '../../shared/redux/pages/slice';
import { RootState } from '../../shared/redux/store';
import ClickImg from '../../shared/assets/images/click.svg';
import { Pages } from '../../shared/redux/pages/types';
import ChildrenStaic from '../../shared/ui/ChildrenStatic/ChildrenStatic';
import ChildrenOnb from '../../shared/ui/ChildrenOnb/ChildrenOnb';
import Bar from '../../widgets/Bar/Bar';
import buttonMp3 from '../../shared/assets/sound/button_2.mp3';
import whooshMp3 from '../../shared/assets/sound/swoosh_1.mp3';
import { useEffect } from 'react';

const soundButton = new Howl({
  src: [buttonMp3],
});
const soundWhoosh = new Howl({
  src: [whooshMp3],
});

const Onboarding = () => {
  const dispatch = useDispatch();
  const onboardingPage = useSelector((state: RootState) => state.pages.onboardingPage);
  const isSound = useSelector((state: RootState) => state.sound.isSound);

  useEffect(() => {
    if (isSound) {
      soundWhoosh.play();
    }
  }, []);

  const getCls = (page: number) => {
    if (page === 1) {
      return cls.OnboardingOne;
    } else if (page === 2) {
      return cls.OnboardingTwo;
    } else if (page === 3) {
      return cls.OnboardingThree;
    } else if (page === 4) {
      return cls.OnboardingFor;
    } else if (page === 5) {
      return cls.OnboardingFive;
    } else if (page === 6) {
      return cls.OnboardingSix;
    } else if (page === 7) {
      return cls.OnboardingSeven;
    }
  };

  const getText = (page: number) => {
    if (page === 1) {
      return (
        <div className={cls.text}>
          <p className={cls.second_p}>
            Иногда цель кажется недостижимой как вершина горы. Но с поддержкой наставника все
            становится проще и покоряются даже невиданные высоты.
          </p>
          <p className={cls.first_p}>
            Иногда цель кажется недостижимой как вершина горы. Но с поддержкой наставника все
            становится проще и покоряются даже невиданные высоты.
          </p>
        </div>
      );
    } else if (page === 2) {
      return (
        <div className={cls.text}>
          <p className={cls.second_p}>
            Наставник! Мы готовы к восхождению, но боимся облажаться. Помоги нам!
          </p>
          <p className={cls.first_p}>
            Наставник! Мы готовы к восхождению, но боимся облажаться. Помоги нам!
          </p>
        </div>
      );
    } else if (page === 3) {
      return (
        <div className={cls.text}>
          <p className={cls.second_p}>
            Если ученик останавливается, тапай по нему, чтобы он полез дальше и не упал.
          </p>
          <p className={cls.first_p}>
            Если ученик останавливается, тапай по нему, чтобы он полез дальше и не упал.
          </p>
        </div>
      );
    } else if (page === 4) {
      return (
        <div className={cls.text}>
          <p className={cls.second_p}>
            Если начинает сползать или падать, тапай, чтобы его поймать.
          </p>
          <p className={cls.first_p}>
            Если начинает сползать или падать, тапай, чтобы его поймать.
          </p>
        </div>
      );
    } else if (page === 6) {
      return (
        <div className={cls.text}>
          <p className={cls.second_p}>
            Альпинистский крюк удержит ученика на месте. <br />
            Тапай и переноси на ученика
          </p>
          <p className={cls.first_p}>
            Альпинистский крюк удержит ученика на месте. <br />
            Тапай и переноси на ученика
          </p>
        </div>
      );
    } else if (page === 5) {
      return (
        <div className={cls.text}>
          <p className={cls.second_p}>
            {' '}
            Используй суперспособности, чтобы успеть помочь всем.
            <br />
            <br />
            Волшебный пендель – поможет всем 5 секунд лезть вверх без остановки.
          </p>
          <p className={cls.first_p}>
            {' '}
            Используй суперспособности, чтобы успеть помочь всем.
            <br />
            <br />
            Волшебный пендель – поможет всем 5 секунд лезть вверх без остановки
          </p>
        </div>
      );
    } else if (page === 7) {
      return (
        <div className={cls.text}>
          <p className={cls.second_p}>
            Помни: сила наставника не бесконечна. Отслеживать ресурс можно по шкале вверху экрана.
          </p>
          <p className={cls.first_p}>
            Помни: сила наставника не бесконечна. Отслеживать ресурс можно по шкале вверху экрана.
          </p>
        </div>
      );
    }
  };
  return (
    <div className={cls.bgContainer}>
      <div className={`${cls.Onboarding} ${getCls(onboardingPage)}`}>
        {onboardingPage > 2 && onboardingPage < 5 && (
          <img alt="Click" src={ClickImg} className={cls.clickImage} />
        )}
        {onboardingPage === 1 && <Cloudes />}
        {onboardingPage === 2 && <ChildrenStaic />}
        {onboardingPage > 2 && (
          <>
            <ChildrenOnb /> <Bar />
          </>
        )}

        {getText(onboardingPage)}
        <Sound />
        {onboardingPage > 1 && (
          <img
            alt="Before"
            src={nextImg}
            className={cls.beforeImage}
            onClick={() => {
              if (isSound) {
                soundButton.play();
              }
              dispatch(setOnboardingPage(false));
            }}
          />
        )}
        {onboardingPage < 7 && (
          <img
            alt="Next"
            src={nextImg}
            className={cls.nextImage}
            onClick={() => {
              if (isSound) {
                soundButton.play();
              }
              dispatch(setOnboardingPage(true));
            }}
          />
        )}
        {onboardingPage === 7 && (
          <>
            <button
              onClick={() => {
                if (isSound) {
                  soundButton.play();
                }
                dispatch(setPage(Pages.GAME));
              }}>
              <p>Начать</p>
            </button>
          </>
        )}
      </div>
    </div>
  );
};

export default Onboarding;
